import {
  Button,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Text,
  VStack,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import {
  FacebookLogo,
  Link,
  ShareNetwork,
  WhatsappLogo,
} from "@phosphor-icons/react";
import { useRef } from "react";
import { Course } from "../const/types";

type Props = {
  data: Course;
};

export default function ShareCourse({ data }: Props) {
  // const postUrl = `https://course.kubu.id/allcourses/${data.id}`;
  const postUrl = `https://r.course.kubu.id/api/allcourses/${data.id}/redirect`;
  const postUrl2Copied = `Kubu Online Course : ${data.nama_course}\n\nhttps://r.course.kubu.id/api/allcourses/${data.id}/redirect`;

  const shareToWhatsapp = () => {
    const shareText = encodeURIComponent(
      `Kubu Online Course : *${data.nama_course}*\n\n${postUrl}`
    );
    const shareUrl = `whatsapp://send?text=${shareText}`;
    window.location.href = shareUrl;
  };

  const shareToFacebook = () => {
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      postUrl
    )}`;
    window.open(shareUrl, "_blank");
  };

  // const shareToTwitter = () => {
  //   const shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
  //     postUrl
  //   )}&text=${encodeURIComponent(data.nama_course)}`;
  //   window.open(shareUrl, "_blank");
  // };

  // const shareViaEmail = () => {
  //   const subject = encodeURIComponent("Lihat postingan blog ini");
  //   const body = encodeURIComponent(
  //     `Saya pikir Anda mungkin menganggap postingan blog ini menarik:\n${data.nama_course}\n${postUrl}`
  //   );
  //   const shareUrl = `mailto:?subject=${subject}&body=${body}`;
  //   window.location.href = shareUrl;
  // };

  const inputRef = useRef<HTMLTextAreaElement | null>(null);

  const copyToClipboard = () => {
    if (inputRef.current) {
      inputRef.current.select();
      navigator.clipboard
        .writeText(inputRef.current.value)
        .then(() => {
          console.log("Teks berhasil disalin ke clipboard.");
          window.getSelection()?.removeAllRanges();
        })
        .catch((err) => {
          console.error("Tidak dapat menyalin teks ke clipboard: ", err);
        });
    }
  };
  const toast = useToast();

  const shareOptions = [
    { name: "Whatsapp", icon: WhatsappLogo, link: shareToWhatsapp },
    { name: "Facebook", icon: FacebookLogo, link: shareToFacebook },
    // { name: "Twitter", icon: TwitterLogo, link: shareToTwitter },
    // { name: "Email", icon: Envelope, link: shareViaEmail },
  ];

  const { isOpen, onOpen, onClose } = useDisclosure();
  const primaryText = "p.500";

  return (
    <>
      <Button
        w={"fit-content"}
        leftIcon={<Icon as={ShareNetwork} weight="fill" />}
        colorScheme="p"
        variant={"ghost"}
        className="clicky"
        h={"50px"}
        onClick={onOpen}
      >
        Bagikan
      </Button>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside"
        isCentered
      >
        <ModalOverlay />

        <ModalContent>
          <ModalCloseButton />

          <ModalHeader>Share</ModalHeader>

          <ModalBody pb={6}>
            <SimpleGrid columns={[2]} gap={4} mb={4}>
              {shareOptions.map((share, i) => (
                <VStack
                  key={i}
                  p={4}
                  bg={"var(--divider)"}
                  borderRadius={8}
                  cursor={"pointer"}
                  onClick={share.link}
                  _hover={{ bg: "var(--divider2)" }}
                >
                  <Icon
                    as={share.icon}
                    fontSize={50}
                    weight="fill"
                    color={primaryText}
                  />
                  <Text color={primaryText} fontWeight={500}>
                    {share.name}
                  </Text>
                </VStack>
              ))}
            </SimpleGrid>

            <textarea
              ref={inputRef}
              defaultValue={postUrl2Copied}
              style={{ position: "absolute", left: "-9999px" }}
            />

            <Button
              className="copyUrlButton"
              colorScheme="p"
              w={"100%"}
              leftIcon={<Icon as={Link} fontSize={20} weight="bold" />}
              fontWeight={600}
              onClick={() => {
                copyToClipboard();
                toast({
                  title: "Tautan berhasil disalin",
                  duration: 5000,
                  isClosable: true,
                });
              }}
            >
              Copy Link URL
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
